import React from "react";
import { useLocation, useNavigate } from "react-router-dom";
import GridHelper from "../helpers/gridHelper";
import FilterBar from "../common/FilterBar";

// Confirmed against real data (dev/QA/prod RunbookExecutionHistory) rather than the
// RunbookStatus enum — Error and NotStarted have zero occurrences anywhere and Status isn't
// actually DB-enforced, so the enum isn't authoritative. "Runbook Timeout" is stored WITH a
// space (unlike the enum's RunbookTimeout), and "Canceling" is real too — hand-listed with
// explicit labels rather than derived via Utils.fixCamelCase, since that space breaks the
// camelCase-splitting assumption for one of these.
const STATUS_OPTIONS = [
  { value: "InProcess", label: "In Process" },
  { value: "Completed", label: "Completed" },
  { value: "CompletedWithErrors", label: "Completed With Errors" },
  { value: "AuthenticationFailed", label: "Authentication Failed" },
  { value: "Runbook Timeout", label: "Runbook Timeout" },
  { value: "Rejected", label: "Rejected" },
  { value: "Canceling", label: "Canceling" },
  { value: "Cancelled", label: "Cancelled" },
];

const FILTER_DEFS = [
  {
    key: "status",
    label: "Status",
    type: "multiselect",
    pinned: true,
    operators: [{ value: "equals", label: "Equals" }],
    options: STATUS_OPTIONS,
  },
  {
    key: "startTime",
    label: "Start Time",
    type: "dateRange",
    fromKey: "startDate",
    toKey: "endDate",
    operators: [
      { value: "between", label: "Is between" },
      { value: "after", label: "Is after" },
      { value: "before", label: "Is before" },
    ],
  },
];

function RunbookExecutionHistoryGridFilter(props) {
  const location = useLocation();
  const navigate = useNavigate();

  // `onSearch`, when given, replaces the default "write the filter into the global URL"
  // behavior — needed when this filter is embedded in a workspace window that owns its own
  // local filter state instead of sharing the single browser URL (see
  // RunbookExecutionHistoryGrid).
  const applyFilter = (nextFilter) =>
    props.onSearch ? props.onSearch(nextFilter) : GridHelper.handleSearch(nextFilter, location, navigate);

  return <FilterBar filterDefs={FILTER_DEFS} value={props.filter} onChange={applyFilter} />;
}

export default RunbookExecutionHistoryGridFilter;
